var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEpgLoadingTablet = function SvgEpgLoadingTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 640,
    fill: "none",
    viewBox: "0 0 960 640"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 364,
    fill: "#1A1A1A",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 48,
    x: 104,
    y: 364,
    fill: "#1A1A1A",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 564,
    fill: "#1A1A1A",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 48,
    x: 104,
    y: 564,
    fill: "#1A1A1A",
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 414,
    fill: "#1A1A1A",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 48,
    x: 104,
    y: 414,
    fill: "#1A1A1A",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 514,
    fill: "#1A1A1A",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 48,
    x: 104,
    y: 514,
    fill: "#1A1A1A",
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 614,
    fill: "#1A1A1A",
    rx: 2
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 48,
    x: 104,
    y: 614,
    fill: "#1A1A1A",
    rx: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 464,
    fill: "#1A1A1A",
    rx: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 48,
    x: 104,
    y: 464,
    fill: "#1A1A1A",
    rx: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 70.567,
    height: 20,
    x: 44,
    y: 64,
    fill: "#1A1A1A",
    rx: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 24,
    x: 44,
    y: 100,
    fill: "#1A1A1A",
    rx: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 24,
    x: 44,
    y: 132,
    fill: "#1A1A1A",
    rx: 2
  })));
};
export default SvgEpgLoadingTablet;